import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import { connectionStates } from '../../utils/app-configs';
import * as actionTypes from './constants';

export const connection = handleActions(
    {
        [combineActions(
            actionTypes.SET_SOCKET_CONNECTION,
        )]: (state, { payload }) => payload,
    },
    { state: connectionStates.Closed },
);

export const subscriptions = handleActions(
    {
        [combineActions(
            actionTypes.SUBSCRIBE_SUCCESS,
        )]: (state, { payload }) => [
            ...(state || []).filter(f => f !== payload.entityId),
            payload.entityId,
        ],
        [combineActions(
            actionTypes.UNSUBSCRIBE_SUCCESS,
            actionTypes.SUBSCRIBE_FAILURE,
            actionTypes.SUBSCRIBE,
        )]: (state, { payload }) => (state || []).filter(f => f !== payload.entityId),
        [combineActions(
            actionTypes.SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
        )]: (state, { payload }) => [
            ...(state || []).filter(f => !f.includes(payload.split('_')[3])),
            payload,
        ],
        [combineActions(
            actionTypes.UNSUBSCRIBE_TO_PLANNINGBOARD_EVENTS_SUCCESS,
            actionTypes.SUBSCRIBE_TO_PLANNINGBOARD_EVENTS_FAILURE,
        )]: (state, { payload }) => (state || []).filter(f => !f.includes(payload.split('_')[3])),
    },
    [],
);

export default combineReducers({
    connection,
    subscriptions,
});
